interface HistoryResponsibilityLetterRequestDTO {
  partnerCompany: string;
}

enum ResponsibilityLetterOperatorsEnum {
  PORTAL = 'API_B2B',
}

interface HistoryResponsibilityLetterProps {
  createdAt: string;
  mainPartnerCompany: string;
  observation: string;
  operator: ResponsibilityLetterOperatorsEnum | string;
  partnerCompany: string;
  sequenceCode: string;
  specialObservation: string;
  typeCode: string;
}

interface HistoryResponsibilityLetterResponseDTO {
  content: HistoryResponsibilityLetterProps[];
}

export {
  type HistoryResponsibilityLetterRequestDTO,
  type HistoryResponsibilityLetterProps,
  type HistoryResponsibilityLetterResponseDTO,
  ResponsibilityLetterOperatorsEnum,
};
